import { css } from '@linaria/atomic';

/**
 * AIR Trainer Loader - "Human in the Loop" animation
 *
 * Three dots represent conversation flow:
 * - Left & right dots: AI activity
 * - Center dot with pulsing ring: Human trainer taking over
 */

const keyframes = `
  @keyframes loader-ring-pulse {
    0%, 100% { transform: scale(1); opacity: 0.5; }
    50% { transform: scale(1.4); opacity: 0; }
  }
  
  @keyframes loader-dot-left {
    0%, 20%, 100% { opacity: 0.3; }
    30%, 50% { opacity: 1; }
  }
  
  @keyframes loader-dot-center {
    0%, 30%, 100% { opacity: 0.3; }
    40%, 60% { opacity: 1; }
  }
  
  @keyframes loader-dot-right {
    0%, 50%, 100% { opacity: 0.3; }
    60%, 80% { opacity: 1; }
  }
`;

export const loaderContainerStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--fabric-color-surface-default, #fff);
  z-index: 9999;
  ${keyframes}
`;

export const loaderSvgStyles = css`
  width: 100px;
  height: 50px;
`;

export const dotLeftStyles = css`
  fill: var(--fabric-color-border-subtle, #d1d5db);
  animation: loader-dot-left 2s ease-in-out infinite;
`;

export const dotCenterStyles = css`
  fill: var(--fabric-color-primary-default, #3b82f6);
  animation: loader-dot-center 2s ease-in-out infinite;
`;

export const dotRightStyles = css`
  fill: var(--fabric-color-border-subtle, #d1d5db);
  animation: loader-dot-right 2s ease-in-out infinite;
`;

export const ringStyles = css`
  fill: none;
  stroke: var(--fabric-color-primary-50, #eff6ff);
  stroke-width: 2;
  transform-origin: center;
  animation: loader-ring-pulse 2s ease-in-out infinite;
`;
